import { render, staticRenderFns } from "./importNewPharmacyPotential.vue?vue&type=template&id=534d11f1"
import script from "./importNewPharmacyPotential.vue?vue&type=script&lang=js"
export * from "./importNewPharmacyPotential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports